import angular from 'angular';
import { routes } from './routes';
import { react2angular } from 'react18-react2angular';
import CrmPessoasDetailsView from './details';
import CrmPessoasListView from './list';
import CrmPessoasAddView from '../pessoas/form';
import { useContext } from '@components';
export default angular
    .module('app.crm.pessoas', [])
    .config(routes)
    .component('crmPessoasDetailsView', react2angular(useContext.use(CrmPessoasDetailsView), [], ['$state', 'CrmService', 'AuthorizationService']))
    .component('crmPessoasListView', react2angular(useContext.use(CrmPessoasListView), [], ['$state', 'CrmService']))
    .component('crmPessoasAddView', react2angular(useContext.use(CrmPessoasAddView), [], ['$state', 'CrmService'])).name;
